/* ===== engine/render/layercache.ts — 화면 한 장짜리 그림(그라디언트 · 비네트)을 한 번 구워 두고 얹기 ===== */
/* ★ 소프트웨어 그리기(저사양 · GPU 없는 기기)에서 화면을 덮는 방사 그라디언트는 4.8ms, 선형은 3.5ms 인데 구운 그림을 얹는 것은 0.5~0.9ms 다.
   열쇠(색 · 크기)가 같은 동안은 다시 굽지 않는다 — 기기 화소 크기로 구워 화소가 원래 그리던 것과 같다. 사연: docs/code-history.md#h247 */

export class LayerCache {
  declare cv: HTMLCanvasElement | null; declare key: string;
  constructor() { this.cv = null; this.key = ''; }
  /** (0, 0)~(W, H) 에 얹는다 — 지금 변환으로 그 넓이가 기기 화소 dw × dh 면 그 크기로 굽는다. vertical 이면 폭 1 줄로 굽고 옆으로 늘린다(세로로만 바뀌는 그라디언트).
      paint(g, w, h) 는 기기 화소 좌표로 그린다. */
  draw(c: CanvasRenderingContext2D, key: string, W: number, H: number, paint: (g: CanvasRenderingContext2D, w: number, h: number) => void, vertical = false): void {
    const m = c.getTransform(), dw = vertical ? 1 : Math.max(1, Math.round(Math.abs(W * m.a))), dh = Math.max(1, Math.round(Math.abs(H * m.d)));
    const k = key + '|' + dw + 'x' + dh;
    if (!this.cv) this.cv = document.createElement('canvas');
    if (k !== this.key) {
      const cv = this.cv;
      if (cv.width !== dw || cv.height !== dh) { cv.width = dw; cv.height = dh; }
      const g = cv.getContext('2d')!;
      g.setTransform(1, 0, 0, 1, 0, 0); g.clearRect(0, 0, dw, dh);
      paint(g, dw, dh); this.key = k;
    }
    const sm = c.imageSmoothingEnabled; c.imageSmoothingEnabled = false;
    c.drawImage(this.cv, 0, 0, W, H);
    c.imageSmoothingEnabled = sm;
  }
}
